/**
 * Exactly the three roles the decision endpoint admits. Admins and super
 * admins review too, so a stylist-only check locks them out of the workspace.
 */
const REVIEW_ROLES = new Set(['stylist', 'admin', 'super_admin']);

export function isStylistRole(role: string): boolean {
  return REVIEW_ROLES.has(role);
}

export function tokenIsExpired(token: string, now = Date.now()): boolean {
  try {
    const payload = token.split('.')[1];
    if (!payload) return true;
    const decoded = JSON.parse(atob(payload.replaceAll('-', '+').replaceAll('_', '/'))) as {
      exp?: unknown;
    };
    return typeof decoded.exp !== 'number' || decoded.exp * 1000 <= now;
  } catch {
    return true;
  }
}

export function invalidatesSession(status: number | undefined): boolean {
  return status === 401;
}

export function resolveApiBaseUrl(value: string, production: boolean): string {
  const url = new URL(value);
  const loopback =
    url.hostname === 'localhost' ||
    url.hostname.endsWith('.localhost') ||
    url.hostname === '127.0.0.1' ||
    url.hostname === '[::1]';
  if (url.username || url.password || url.search || url.hash) {
    throw new Error('API URL must not contain credentials, query parameters, or a hash.');
  }
  if (production && (url.protocol !== 'https:' || loopback)) {
    throw new Error('Production Stylist API must use a non-loopback HTTPS origin.');
  }
  return url.toString().replace(/\/$/, '');
}
